module.exports = __webpack_public_path__ + "img/rule-in.03c4b66e.png";